<template>
  <!-- 新增的对话框 -->
  <el-dialog
    center
    width="600px"
    title="编辑用户"
    :visible.sync="dialogFormVisible"
    @closed="closed"
  >
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <el-form-item label="状态" :label-width="formLabelWidth">
        <el-cascader
          v-model="value"
          :options="options"
          placeholder="请选择活动区域"
          @change="changeStatus"
          :show-all-levels="false"
        >
        </el-cascader>
      </el-form-item>

      <!-- 已签约(租) -->
      <div v-if="childStatus == 7">
        <el-form-item
          label="租赁起止时间"
          :label-width="formLabelWidth"
          prop="timeLimit"
        >
          <!-- <el-input v-model="editForm.timeLimit"  autocomplete="off"></el-input> -->
          <el-date-picker
            v-model="dateTime"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            prop="dateTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item
          label="租赁天数"
          :label-width="formLabelWidth"
          prop="rentCycle"
        >
          <el-input v-model="editForm.rentCycle" autocomplete="off"></el-input>
        </el-form-item>
      </div>

      <!-- 已签约(购) / 已签约(租)  -->
      <div v-if="childStatus == 7 || childStatus == 8">
        <el-form-item
          :label="childStatus == 7 ? '月租金' : '单价'"
          :label-width="formLabelWidth"
          prop="unitPrice"
        >
          <el-input
            v-model="editForm.unitPrice"
            autocomplete="off"
            :type="childStatus == 7 ? 'number' : 'text'"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="总价"
          :label-width="formLabelWidth"
          prop="totalPrice"
        >
          <el-input
            v-model="editForm.totalPrice"
            autocomplete="off"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="合同备注"
          :label-width="formLabelWidth"
          prop="explain"
        >
          <el-input
            v-model="editForm.explain"
            type="textarea"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="签约时间"
          :label-width="formLabelWidth"
          prop="signedTime"
        >
          <!-- <el-input v-model="editForm.signedTime"  autocomplete="off"></el-input> -->

          <el-date-picker
            v-model="date"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="变更状态描述"
          :label-width="formLabelWidth"
          prop="reviewOpinion"
        >
          <el-input
            v-model="editForm.reviewOpinion"
            type="textarea"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </div>

      <el-form-item
        v-if="editForm.status !== 4"
        label="审批意见"
        :label-width="formLabelWidth"
        prop="opinion"
      >
        <el-input
          type="textarea"
          v-model="editForm.opinion"
          autocomplete="off"
          placeholder="请输入审批意见"
        ></el-input>
      </el-form-item>
      <el-form-item
        v-if="isTimeOut || childStatus === 2"
        label="销售员姓名"
        :label-width="formLabelWidth"
        prop="salesmanName"
      >
        <el-select
          class="select"
          v-model="editForm.salesmanName"
          filterable
          remote
          placeholder="请输入销售员名字"
          :remote-method="searchUser"
          @change="checkItem"
          clearable
          @clear="editForm.salesmanName = ''"
          :loading="loading"
        >
          <el-option
            v-for="item in userOptions"
            :key="item.value"
            :label="handleUserDecrypt(item.label, item.isShowAllPhone)"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="isTimeOut || childStatus === 2"
        label="客服姓名"
        :label-width="formLabelWidth"
        prop="servicePersonName"
      >
        <el-select
          class="select"
          v-model="editForm.servicePersonName"
          filterable
          remote
          placeholder="请输入客服姓名"
          :remote-method="searchUser"
          @change="checkServicePerson"
          clearable
          @clear="editForm.servicePersonName = ''"
          :loading="loading"
        >
          <el-option
            v-for="item in userOptions"
            :key="item.value"
            :label="handleUserDecrypt(item.label, item.isShowAllPhone)"
            :value="item.label"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { getUserModelApi, getUserStatusListApi } from '@/api/user.js';
import { changeStatusApi } from '@/api/introduce';
import { decrypt } from '@/utils/encryp';
// import { getToken } from '@/utils/token.js'
export default {
  name: 'ChangeStatus',
  data() {
    return {
      formLabelWidth: '120px', // 对话框中 文本的尺寸
      dialogFormVisible: false, // 是否显示对话框
      dateTime: '',
      date: '',
      value: '',
      isTimeOut: false, //已失效或已过期
      userOptions: [],
      loading: false,
      // 编辑表单
      editForm: {
        appRecordId: '',
        opinion: '',
        timeLimit: '',
        unitPrice: '',
        totalPrice: '',
        rentCycle: '',
        explain: '',
        signedTime: '',
        reviewOpinion: '',
        salesmanName: '',
        servicePersonName: '',
      },
      // 表单的验证规则
      editRules: {
        salesmanName: [
          { required: true, message: '销售员姓名不能为空！', trigger: 'blur' },
        ],
        opinion: [
          { required: true, message: '审批意见不能为空！', trigger: 'blur' },
        ],
        rentCycle: [
          { required: true, message: '租赁天数不能为空！', trigger: 'blur' },
        ],
        unitPrice: [
          { required: true, message: '该值不能为空！', trigger: 'blur' },
        ],
        totalPrice: [
          { required: true, message: '总价不能为空！', trigger: 'blur' },
        ],
        explain: [
          { required: true, message: '合同备注不能为空！', trigger: 'blur' },
        ],
        signedTime: [
          { required: true, message: '签约时间不能为空！', trigger: 'blur' },
        ],
        timeLimit: [
          {
            required: true,
            message: '租赁起止时间不能为空！',
            trigger: 'blur',
          },
        ],
        reviewOpinion: [
          {
            required: true,
            message: '变更状态描述不能为空！',
            trigger: 'blur',
          },
        ],
      },
      // ['全部', '未到访', '已到访', '已分配','已过期','人工分配','已失效', '已签约', '复核可结佣', '已结佣']
      options: [
        // { label: '未到访', value: '未到访' },
        // { label: '已到访', value: '已到访' },
        // { label: '已分配', value: '已分配' },
        // { label: '已过期', value: '已过期' },
        // { label: '人工分配', value: '人工分配' },
        // { label: '已失效', value: '已失效' },
        // {
        //   label: '已签约(租)',
        //   value: '已签约(租)',
        // },
        // {
        //   label: '已签约(售)',
        //   value: '已签约(售)',
        // },
        // { label: '复核可结佣', value: '复核可结佣' },
        // { label: '已结佣', value: '已结佣' },
      ],
      childStatus: '',
    };
  },
  computed: {
    ...mapGetters(['pickerOptions']),
  },
  watch: {
    // 将标准时间转换成 yyyy-mm-dd
    dateTime(val) {
      let timeList = val.map((item) => {
        return this.$moment(item).format('YYYY-MM-DD HH:mm:ss');
      });
      return (this.editForm.timeLimit = timeList.join(','));
    },
    date(val) {
      return (this.editForm.signedTime = this.$moment(val).format(
        'YYYY-MM-DD HH:mm:ss'
      ));
    },
  },
  mounted() {
    this.getStatusList();
  },
  methods: {
    getStatusList() {
      getUserStatusListApi({ typeName: 'UserAppointState' }).then((res) => {
        // console.log('获取状态列表：', res.data);
        const list = res.data;
        list.length &&
          list.map((item) => {
            this.options.push({
              label: item.name,
              value: item.value,
            });
          });
      });
    },
    changeStatus(val) {
      // try {
      //   // let status = val[val.length - 1];
      //   this.options.forEach((item, index) => {
      //     // 获取选择的下标， 由于数组0-5， status参数是1-6，所以要加一
      //     // if (item.children) {
      //     //   item.children.forEach((key, i) => {
      //     //     if (item.value == status || key.value == status) {
      //     //       // 已签约有两种状态， 7-1是租， 7-2是购，此参数用来做标记不传后端
      //     //       this.editForm.status = index + 1;
      //     //       // this.childStatus = index + 1 + '-' + (i + 1);
      //     //     }
      //     //   });
      //     // }
      //     if (item.value == status) {
      //       this.editForm.status = index + 1;
      //       this.childStatus = index + 1;
      //     }
      //   });
      // } catch (e) {
      //   window.console.log(e);
      // }
      this.editForm.status = val[0];
      this.childStatus = val[0];
    },
    // 提交按钮
    submitEdit() {
      const areaId = localStorage.getItem('areaId')
        ? JSON.parse(localStorage.getItem('areaId')).areaId
        : '';
      let data =
        'appRecordId=' +
        this.editForm.appRecordId +
        '&opinion=' +
        this.editForm.opinion +
        '&salesmanName=' +
        this.editForm.salesmanName +
        '&servicePersonName=' +
        this.editForm.servicePersonName +
        '&areaId=' +
        areaId;
      /**
       * 2022-10-12 研祥通 吴
       * 帮忙修改一个接口的参数：
       * 客户管理-->报备成功-->变更状态-->已到访
       * URL: userAdmin/Introduce/toVisted
       * 修改参数：将salesPersonName修改为salesUserId
       * 修改说明：salesUserId为选择的销售人员的userId
       *
       */
      let dataToVisited =
        'appRecordId=' +
        this.editForm.appRecordId +
        '&opinion=' +
        this.editForm.opinion +
        '&salesUserId=' +
        (this.editForm.salesmanName || '') +
        '&customerServicePersonName=' +
        (this.editForm.servicePersonName
          ? this.handleUserDecrypt(this.editForm.servicePersonName)
          : '') +
        '&areaId=' +
        areaId;
      let data2 = {
        appRecordId: this.editForm.appRecordId,
        unitPrice: this.editForm.unitPrice,
        totalPrice: Number(this.editForm.totalPrice),
        explain: this.editForm.explain,
        signedTime: this.editForm.signedTime,
        reviewOpinion: this.editForm.reviewOpinion,
        areaId,
      };
      let data3 = {
        appRecordId: this.editForm.appRecordId,
        rentMonthPrice: this.editForm.unitPrice,
        totalPrice: Number(this.editForm.totalPrice),
        explain: this.editForm.explain,
        signedTime: this.editForm.signedTime,
        reviewOpinion: this.editForm.reviewOpinion,
        timeLimit: this.editForm.timeLimit,
        rentCycle: Number(this.editForm.rentCycle),
        areaId,
      };
      try {
        this.$refs.editForm.validate(async (valid) => {
          if (!valid) return;
          // console.log('状态值：', this.childStatus);
          // console.log('提交的参数：', data);
          switch (this.childStatus) {
            case 2:
              // 已到访
              await changeStatusApi('toVisited', dataToVisited).then((res) => {
                this.res1 = res;
              });
              break;
            case 3:
              // 已分配
              await changeStatusApi('toAssigned', data).then((res) => {
                this.res1 = res;
              });
              break;
            case 4:
              // 已过期
              await changeStatusApi('toExpired', data).then((res) => {
                this.res1 = res;
              });
              break;
            case 5:
              // 人工分配
              await changeStatusApi('toManualAssignment', data).then((res) => {
                this.res1 = res;
              });
              break;
            case 6:
              // 已失效
              await changeStatusApi('toInvalidate', data).then((res) => {
                this.res1 = res;
              });
              break;
            case 7:
              // 已签约（租）
              await changeStatusApi('toSignedForRent', data3, false).then(
                (res) => {
                  this.res1 = res;
                }
              );
              break;
            case 8:
              // 已签约（购）
              await changeStatusApi('toSignedForSale', data2, false).then(
                (res) => {
                  this.res1 = res;
                }
              );
              break;
            case 9:
              // 复核可结佣
              await changeStatusApi('toServable', data).then((res) => {
                this.res1 = res;
              });
              break;
            case 10:
              // 已结佣
              await changeStatusApi('toPayment', data).then((res) => {
                this.res1 = res;
              });
              break;
            default:
              // this.$message.error(
              //   '不支持状态往回修改，如需修改请联系您的管理员'
              // );
              break;
          }
          if (this.res1 && this.res1.code === 200) {
            this.$message.success('变更成功！');
            this.dialogFormVisible = false;
            this.$refs.editForm.resetFields();
            this.$emit('fetchData');
          } else {
            // this.$message.error(this.res1 && this.res1.message);
          }
        });
      } catch (e) {
        window.console.log(e);
      }
    },
    // 关闭时的回调
    closed() {
      this.editForm.status = '';
      this.childStatus = '';
      this.value = null;
    },
    // 搜索用户名
    async searchUser(val) {
      this.loading = true;
      const areaId = localStorage.getItem('areaId')
        ? JSON.parse(localStorage.getItem('areaId')).areaId
        : '';
      let res = await getUserModelApi({ userName: val, areaId });
      this.loading = false;
      this.userOptions = JSON.parse(
        JSON.stringify(res.data.dataList)
          .replace(/nickName/g, 'label')
          .replace(/userId/g, 'value')
      );
    },
    // 解密用户名和手机号码
    handleUserDecrypt(str, isShowAll) {
      if (!str) return;
      let index1 = str.indexOf('(');
      let index2 = str.indexOf(')');
      let str2 = str.substring(index1 + 1, index2);
      let str1 = str.replace(`(${str2})`, '');
      return `${decrypt(str1)}(${
        isShowAll
          ? decrypt(str2)
          : decrypt(str2).replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      })`;
    },
    // 获取用户名传给的后端
    getUserName(str) {
      if (!str) return;
      let index1 = str.indexOf('(');
      let index2 = str.indexOf(')');
      let str2 = str.substring(index1 + 1, index2);
      let str1 = str.replace(`(${str2})`, '');
      return str1;
    },
    // 选择用户名下拉选项
    checkItem(val) {
      this.editForm.salesmanName = val;
    },
    // 选择客户下拉选项
    checkServicePerson(val) {
      // console.log('选择客户下拉选项',val)
      this.editForm.servicePersonName = val;
    },
  },
  created() {},
};
</script>

<style lang="less" scoped></style>
